import {injectable} from "inversify";

@injectable()
export default class IsMobileService {
    isIPad(): boolean {
        return ((!!navigator.maxTouchPoints &&
            navigator.maxTouchPoints > 2 &&
            /MacIntel/.test(navigator.platform)) || this._isMobile());
    }
    
    /* ATTENTION: This is incomplete, unreliable and currently added to support chrome on ipads. */
    private _isMobile(): boolean {
        return /Mobile/.test(navigator.userAgent);
    }
}


@injectable()
export class IsMobileServiceMock {
    isIPad(): boolean {
        return false;
    }
}